import { CreateHandoutContainer } from 'modules/CreateHandout';
import React from 'react'

type Props = {}

const CreateHandout = (props: Props) => {
    return (
        <CreateHandoutContainer />
    )
}

export default CreateHandout;